import { Header } from './Header/Header';
import { Footer } from './Footer';
import { FullPageDropZone } from './FullPageDropZone';
import * as React from 'react';
import { useAppSelector } from '../../Store/store';
import { fullDropZoneSelector } from '../../Store/layoutSlice';

export const Container = ({ children }) => {
  const fullDropZone = useAppSelector(fullDropZoneSelector);

  const wrappedChildren = (
    <div className="container-fluid min-vh-100 d-flex flex-column">
      <Header />
      {children}
      <div className="container-fluid bg-success g-0 nopadding mt-auto">
        <Footer />
      </div>
    </div>
  );

  return (
    <>
      {fullDropZone && <FullPageDropZone>{wrappedChildren}</FullPageDropZone>}
      {!fullDropZone && wrappedChildren}
    </>
  );
};
